import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=73d1b3f0&scoped=true"
import script from "./BusinessDetails.vue?vue&type=script&lang=ts"
export * from "./BusinessDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d1b3f0",
  null
  
)

export default component.exports